import { SureError, TVgsFormSubmitResponse } from '../interfaces';

import api from './api';

const formatExpirationDate = (cardExp: string) => {
  return cardExp.split(' ').join('').split('/');
};
const nextYear = (new Date().getFullYear() + 1).toString();

export const handleVgsTokenExchange = async ({
  space,
  apiUrl,
  vgsFormSubmitResponse,
  paymentApiAuthToken,
  name: holderName,
  isTestMode = false,
}: {
  space: string;
  apiUrl: string;
  vgsFormSubmitResponse: TVgsFormSubmitResponse;
  paymentApiAuthToken: string;
  name?: string;
  isTestMode?: boolean;
}) => {
  const { card_cvc, card_number, card_exp } = vgsFormSubmitResponse;
  const expirationParts = formatExpirationDate(card_exp);

  const fullYearLeadingDigits = new Date()
    .getFullYear()
    .toString()
    .substring(0, 2);

  const expYear =
    expirationParts[1].length === 2
      ? `${fullYearLeadingDigits}${expirationParts[1]}`
      : expirationParts[1];

  const tokenExchangePayload = {
    type: 'card',
    cardNumberToken: card_number,
    expMonth: isTestMode ? '10' : expirationParts[0],
    expYear: isTestMode ? nextYear : expYear,
    cvcToken: card_cvc,
    carrierCode: space,
    paymentApiAuthToken,
    apiUrl,
  };

  const {
    card,
    gateway_reference_id: gatewayReferenceId,
    id: paymentServiceId,
  } = await api.exchangeVgsToken(tokenExchangePayload);

  if (card.funding === 'prepaid') {
    throw new SureError({
      code: 'prepaid_payment_method',
      message: 'Prepaid payment method cannot be used',
    });
  }

  return {
    card,
    gateway_reference_id: gatewayReferenceId,
    id: paymentServiceId,
    name: holderName,
  };
};
